import {
    GET_GROUPS_LIST_REQUEST, GET_GROUPS_LIST_SUCCESS, GET_GROUPS_LIST_FAILURE, SET_GROUPS_FILTERED,
} from '../constants/get_groups_list.constants';

export const getGroupsListRequest = _id => ({
    type: GET_GROUPS_LIST_REQUEST, _id,
});

export const getGroupsListSuccess = groupsList => ({
    type: GET_GROUPS_LIST_SUCCESS,
    groupsList,
});

export const setFilterGroups = searchText => ({
    type: SET_GROUPS_FILTERED,
    searchText,
});

export const getGroupsListFailure = error => ({
    type: GET_GROUPS_LIST_FAILURE,
    error,
});



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group/redux/actions/get_groups_list.actions.js